import { Component, OnInit, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { OrderService } from '../order-dashboard/order.service';
import { DatePipe } from '@angular/common';
import { MatPaginator } from '@angular/material/paginator';
import { MapDialogComponent } from '../../shared/map-dialog/map-dialog.component';
import { MyOrdersService } from './my-orders.service';
import { DownloadExcelService } from 'src/app/services/download-excel.service';

@Component({
  selector: 'app-my-orders',
  templateUrl: './my-orders.component.html',
  styleUrls: ['./my-orders.component.scss'],
  providers: [DatePipe]
})
export class MyOrdersComponent implements OnInit {
  excelData: any[];
  public totalSize = 0;
  orders: any[] = []; displayedColumns = ['BookingIdCode', 'OrderIdCode', 'ServiceType', 'Origin', 'Via1', 'Via2', 'Destination', 'VehicleNo', 'ToPlacementTime', 'Freight', 'StatusOfOrder'];
  pageIndex = 0; pageSize = 5; length = 0; lat: any; lng: any; VehicleNo: any; selectedFilter = 'any'; selectedStatus = ''; keyword = ''; fromDate = ''; toDate = ''; showCustomDate = false; dateType = 'YTD';
  @ViewChild(MatPaginator) paginator: MatPaginator;

  constructor(public orderService: OrderService,public dialog: MatDialog, public datePipe: DatePipe, public myorderService: MyOrdersService,
    public _downloadExcelService: DownloadExcelService
  ) { }

  ngOnInit(): void { this.getOrders(); }

  toggleCustomDate() { this.showCustomDate = !this.showCustomDate; if (!this.showCustomDate) { this.fromDate = ''; this.toDate = ''; } }

  setDateFilter(dateFilter: string) { this.dateType = dateFilter; this.showCustomDate = false; this.getOrders(); }

  getOrders() {
    let data = { 
      DateType: this.dateType || 'YTD', 
      OrderType: "FCL", 
      PageLength: this.pageSize, 
      StartIndex: this.pageIndex * this.pageSize + 1, 
      OrderIdCode: "", 
      BookingIdCode: "",
      FromDate: this.fromDate ? this.datePipe.transform(this.fromDate, 'yyyy-MM-dd') : "", 
      ToDate: this.toDate ? this.datePipe.transform(this.toDate, 'yyyy-MM-dd') : "", 
      VehicleNo: "",
      FilterType: "",
      Status: this.selectedStatus 
    };
  
    if (this.selectedFilter === 'order_id' && this.keyword) {
      data.OrderIdCode = this.keyword; 
    }
    if (this.selectedFilter === 'booking_id' && this.keyword) {
      data.BookingIdCode = this.keyword; 
    }
    if (this.selectedFilter === 'vehicle_number' && this.keyword) {
      data.VehicleNo = this.keyword; 
    }

  
    this.orderService.getOrdersForDashboard(data).subscribe((response: any) => {
      const allOrders = response.Data.OrdersForDashboardList;
      this.length = response.Data.TotalOrdersCount || allOrders.length;
      this.lat = allOrders.map(order => order.Latitude);
      this.lng = allOrders.map(order => order.Longitude);
      this.VehicleNo = allOrders.map(order => order.VehicleNo);
      console.log(this.lat);
      console.log(this.lng);
      console.log(this.VehicleNo);
      this.orders = allOrders; 
    },
     error => console.error('Error fetching orders:', error));
  }
  

  filterOrders(allOrders: any[]): any[] {
    //if (this.selectedFilter === 'order_id' && this.keyword) return allOrders.filter(order => order.OrderIdCode?.toUpperCase().includes(this.keyword.toUpperCase()));
    //if (this.selectedFilter === 'booking_id' && this.keyword) return allOrders.filter(order => order.BookingIdCode?.toUpperCase().includes(this.keyword.toUpperCase()));
    //if (this.selectedFilter === 'vehicle_number' && this.keyword) return allOrders.filter(order => order.VehicleNo?.toUpperCase().includes(this.keyword.toUpperCase()));
    if (this.selectedFilter === 'status' && this.selectedStatus) return allOrders.filter(order => order.StatusOfOrder === this.selectedStatus);
    return allOrders;
  }

  formatDate(date: string) { return this.datePipe.transform(date, 'dd-MM-yyyy'); }

  onPageChange(event: any) { this.pageIndex = event.pageIndex; this.pageSize = event.pageSize; this.getOrders(); }

  applyFilters() { this.getOrders(); }

  clearFilters() { this.selectedFilter = 'any'; this.selectedStatus = ''; this.keyword = ''; this.getOrders(); }

  onFilterChange(event: any) { if (this.selectedFilter !== 'status') this.selectedStatus = ''; }

  public openMap(order) {
    const mapData = {
      Latitude: order.Latitude,
      Longitude: order.Longitude,
      VehicleNo: order.VehicleNo
    };
  
    console.log('Opening Map with:', mapData);
  
    let dialogRef = this.dialog.open(MapDialogComponent, {
      data: {
        data: mapData,
        isService: false,
        vehiclenumber: order.VehicleNo
      },
      height: 'auto',
      width: '600px',
      autoFocus: false
    });
  }

  public exportAsExcel() {
    this.excelData = [];
    let data = {
      DateType: this.dateType || 'YTD',
      OrderType: "FCL",
      PageLength: this.totalSize > 0 ? this.totalSize : 1000,
      StartIndex: 1,
      OrderIdCode: this.selectedFilter === 'order_id' ? this.keyword : "",
      BookingIdCode: this.selectedFilter === 'booking_id' ? this.keyword : "",
      VehicleNo: this.selectedFilter === 'vehicle_number' ? this.keyword : "",
      FromDate: this.fromDate ? this.datePipe.transform(this.fromDate, 'yyyy-MM-dd') : "",
      ToDate: this.toDate ? this.datePipe.transform(this.toDate, 'yyyy-MM-dd') : "",
      FilterType: "",
      Status: this.selectedStatus || ""
    };

    this.myorderService.getBookingConfirmedOrders(data).subscribe(
      (response: any) => {
        const list = response?.Data?.OrdersForDashboardList || [];

        if (list.length > 0) {
          this.excelData = list.map((element: any) => ({
            'Booking Id': element.BookingIdCode || '-',
            'Customer Name': element.CustomerNameFull || '-',
            'Order ID': element.OrderIdCode || '-',
            'Service Type': element.ServiceType || '-',
            'Origin': element.Origin || '-',
            'Via 1': element.Via1 || '-',
            'Via 2': element.Via2 || '-',
            'Destination': element.Destination || '-',
            'Vehicle No.': element.VehicleNo || '-',
            'Placement Date': element.ToPlacementTime? this.datePipe.transform(element.ToPlacementTime, 'dd-MM-yyyy'): '-',
            'Freight': element.Freight || '-',
            'Status': element.StatusOfOrder || '-',
          }));
        } else {
          this.excelData.push({
            'Booking Id': '-',
            'Customer Name': '-',
            'Order ID': '-',
            'Service Type': '-',
            'Origin': '-',
            'Via 1': '-',
            'Via 2': '-',
            'Destination': '-',
            'Vehicle No.': '-',
            'Placement Date': '-',
            'Freight': '-',
            'Status': '-',
          });
        }
        this._downloadExcelService.exportAsExcelFile(this.excelData, 'My Orders');
      },
      error => {
        console.error("Error exporting orders:", error);
      }
    );
  }

}